import React from 'react';
import { Card, Col, Progress, Row, Space, Statistic, Table, Tag, Typography } from 'antd';
import { formatDate } from 'utils/date';

const { Title, Text } = Typography;

const formatBytes = (bytes) => {
  if (!bytes || bytes <= 0) return '0 MB';
  const gb = bytes / (1024 ** 3);
  if (gb >= 1) return `${gb.toFixed(2)} GB`;
  return `${(bytes / (1024 ** 2)).toFixed(1)} MB`;
};

const Desktop = ({ viewModel }) => {
  const { summary, packageLabels } = viewModel;

  const newShopColumns = [
    {
      title: 'Shop',
      render: (_, record) => record?.web_site?.title || '-',
    },
    {
      title: 'Domain',
      render: (_, record) => (record?.web_site?.url ? `${record.web_site.url}.sipro.store` : '-'),
    },
    {
      title: 'Chủ shop',
      render: (_, record) => record?.owner?.full_name || '-',
    },
    {
      title: 'SĐT',
      render: (_, record) => record?.owner?.phone || '-',
    },
    {
      title: 'Gói',
      render: (_, record) => packageLabels[record?.subscription?.tier || 'mien_phi'] || 'Miễn phí',
    },
    {
      title: 'Ngày tạo',
      render: (_, record) => formatDate(record?.create_on),
    },
  ];

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Title level={4} style={{ margin: 0 }}>Tổng quan Shop</Title>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card>
            <Statistic title='Tổng số shop' value={summary.totalShops} />
          </Card>
        </Col>
        {Object.keys(packageLabels).map((key) => (
          <Col xs={24} sm={12} md={8} lg={6} key={key}>
            <Card>
              <Statistic
                title={`Shop gói ${packageLabels[key]}`}
                value={summary.byPackage[key] || 0}
              />
            </Card>
          </Col>
        ))}
      </Row>

      {summary.topStorageShops && summary.topStorageShops.length > 0 ? (
        <Card>
          <Space direction='vertical' size={12} style={{ width: '100%' }}>
            <Text strong>Top 5 shop dùng nhiều cloud nhất</Text>
            <Table
              rowKey={(record) => record.id || record._id || record?.web_site?.url}
              size='small'
              pagination={false}
              dataSource={summary.topStorageShops}
              columns={[
                { title: 'Shop', render: (_, r) => r?.web_site?.title || '-' },
                { title: 'Gói', render: (_, r) => <Tag>{packageLabels[r?.subscription?.tier || 'mien_phi']}</Tag> },
                {
                  title: 'Dung lượng',
                  render: (_, r) => {
                    const i = r?.storage_info || {};
                    return `${formatBytes(i.used_bytes)} / ${i.limit_gb ? i.limit_gb + ' GB' : '∞'}`;
                  },
                },
                {
                  title: 'Sử dụng',
                  render: (_, r) => {
                    const p = r?.storage_info?.percent || 0;
                    return (
                      <Progress
                        percent={p}
                        size='small'
                        strokeColor={p >= 95 ? '#ff4d4f' : p >= 75 ? '#faad14' : undefined}
                      />
                    );
                  },
                },
              ]}
            />
          </Space>
        </Card>
      ) : null}

      <Card>
        <Space direction='vertical' size={12} style={{ width: '100%' }}>
          <Text strong>Danh sách shop mới tạo trong 7 ngày gần đây</Text>
          <Table
            rowKey={(record) => record.id || record._id || record?.web_site?.url}
            columns={newShopColumns}
            dataSource={summary.newShops}
            pagination={{ pageSize: 10 }}
          />
        </Space>
      </Card>
    </Space>
  );
};

export default Desktop;
